import { JSX } from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { Button } from '@heroui/react';
import clsx from 'clsx';

interface ProjectAssistantToggleProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Toggle button shown when panel is collapsed.
 */
export function ProjectAssistantToggle({
  disabled = false,
  onClick,
}: ProjectAssistantToggleProps): JSX.Element {
  return (
    <Button
      aria-label="Open AI Chat"
      color="primary"
      onPress={onClick}
      isIconOnly
      size="lg"
      isDisabled={disabled}
      className={clsx(
        'fixed',
        'right-4',
        'z-50',
        'w-12',
        'h-12',
        'rounded-full',
        'transition-all',
        'duration-200',
        'ease-in-out',
        'hover:scale-105',
        'disabled:hover:scale-100',
        'flex',
        'items-center',
        'justify-center',
        {
          'bottom-16': import.meta.env.DEV,
          'bottom-4': !import.meta.env.DEV,
        },
      )}
      title="Open AI Chat"
    >
      <SparklesIcon className="w-6 h-6" />
    </Button>
  );
}
